import { render, staticRenderFns } from "./SaveAssignedRoutineDialog.vue?vue&type=template&id=70d79c4d&scoped=true"
import script from "./SaveAssignedRoutineDialog.vue?vue&type=script&lang=js"
export * from "./SaveAssignedRoutineDialog.vue?vue&type=script&lang=js"
import style0 from "./SaveAssignedRoutineDialog.vue?vue&type=style&index=0&id=70d79c4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d79c4d",
  null
  
)

export default component.exports